import { toast, ToastType } from 'vue3-toastify'

export const callErrorToast = (message: string, title?: string) => callToast(message, 'error', title ?? 'Ошибка')

export const callSuccessToast = (message: string, title?: string) => callToast(message, 'success', title)

const callToast = (message: string, type: ToastType = 'default', title?: string) => {
  toast(createHTMLString(message, title), {
    type,
    dangerouslyHTMLString: true,
  })
}

const createHTMLString = (message: string, title?: string): string => {
  let htmlString = ''
  if (title) htmlString = htmlString + `<p class="text-subtitle-1">${title}</p>`
  htmlString = htmlString + `<p class="text-body-2">${message}</p>`

  return htmlString
}
